import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { CharacteristicsStyled } from '../CharacteristicsStyled';
import { rem } from 'polished';

export const CharacteristicsStyledDS = styled(CharacteristicsStyled)`
    .environmentalWrapper {
        border: 1px solid ${({ theme }) => theme.colors.grey16};
        background: ${({ theme }) => theme.colors.white};
        border-radius: ${rem(8)};
        margin: ${rem(10)};

        @media screen and (min-width: ${breakpoints.sm}px) {
            margin: ${rem(10)} 0;
        }
    }
    .tires-icon svg {
        width: ${rem(16)};
        height: ${rem(16)};
        margin-bottom: -${rem(2)};
        g {
            circle, line {
                stroke: ${({theme}) => theme.colors.black1};
            }
        }
    }
    .technicalTitle {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        font-size: ${rem(32)};
    }
    .technicalSubtitle {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        font-size: ${({ theme }) => theme.fontSizes.h4};
        padding-top: ${rem(24)};
    }
    .techBlock {
        .imageWrapper-gearbox {
            svg {
                width: ${rem(35)};
                height: ${rem(35)};
                path {
                    fill: ${({ theme }) => theme.colors.black1};
                }
            }
        }
        .imageWrapper-fuel {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black1};
                }
            }
        }
        .techWrapper {
            margin-left: ${rem(9)};
            color: ${({ theme }) => theme.colors.black1};
            .techLabel {
                text-transform: unset;
            }
            span {
                color: ${({ theme }) => theme.colors.black1};
            }
        }
    }

    .environmentalWrapper div:first-of-type .environmentalBlock {
        border-right: none;
        padding-right: 1rem;

        @media (min-width: ${rem(992)}) {
            border-right: solid 1px ${({ theme }) => theme.colors.grey16};
        }
    }

    .environmentalBlock {
        .environmentalItem span,
        div {
            color: ${({ theme }) => theme.colors.black};
            font-size: ${({ theme }) => theme.fontSizes.h6};
        }
    }
    .Collapsible {
        &__trigger {
            padding-left: 0;
        }
        .featureTitleWide {
            border-top: none;
        }
    }
    .technicalFeaturesModule {
        .featureList {
            color: ${({ theme }) => theme.colors.black1};
        }
    }
    .legalText {
        color: ${({ theme }) => theme.colors.black};
        font-size: ${({ theme }) => theme.fontSizes.h6};
        a {
            color: ${({ theme }) => theme.colors.black};
        }
    }
    > div {
        > div:nth-last-child(2) {
            border-bottom: none;
        }
    }

    .technicalDetails {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        font-size: ${({ theme }) => theme.fontSizes.h4};

        &-mainBlock {
            padding-left: ${rem(10)};
        }
    }

    .technicalFeaturesModule {
        .featureList {
            font-size: ${({ theme }) => theme.fontSizes.h6};
            color: ${({ theme }) => theme.colors.black};
        }
    }

    .technicalWrapper {
        border-top: none;
    }

    .featureTitle,
    .featureTitleWide,
    .featureValue,
    .featureItemList {
        font-size: ${({ theme }) => theme.fontSizes.h6};
        color: ${({ theme }) => theme.colors.black};
    }

    .featureList {
        .featureInfo {
            text-align: left;
        }

        li {
            font-size: ${({ theme }) => theme.fontSizes.h6};
            color: ${({ theme }) => theme.colors.black};
            margin-left: 0;

            &::before {
                display: none;
            }
        }
    }
`;
